<template>
  <v-card
    class="ma-0 py-2 px-4 pt-4"
    style="background: #F5F5F5"
    outlined
    tile
  >
    <validation-observer ref="validator" v-slot="{ handleSubmit }">
      <h3 class="form-title">
        VUI LÒNG XÁC NHẬN THÔNG TIN (CHÚ Ý THỜI HẠN, SẢN PHẨM, GIÁ TIỀN, ...)
      </h3>
      <span class="close-btn cursor-pointer" @click="close()">
        <v-icon color="#9e9e9e">
          mdi-close
        </v-icon>
      </span>
      <div class="px-2 mt-2" style="border: 1px solid #989898; border-radius: 10px;">
        <v-row>
          <v-col class="pt-3 pb-0" cols="5">
            <span style="font-weight: bold;">
              <v-icon color="#000">
                mdi-circle-small
              </v-icon>
              Hình thức thanh toán: <span style="text-transform: uppercase;">{{ paymentPeriodTxt }}</span>
            </span>
          </v-col>
          <v-col class="pt-3 pb-0" cols="7">
            <v-row>
              <v-col class="py-0 pb-3">
                <span style="font-weight: bold;">
                  <v-icon color="#000">
                    mdi-circle-small
                  </v-icon>
                  Tổng số tiền cần thanh toán: {{ formatCurrency(totalPay) }}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="extraData">
              <v-col class="py-0 pb-3">
                <span style="font-weight: bold;">
                  <v-icon color="#000">
                    mdi-circle-small
                  </v-icon>
                  Số tiền còn lại cần thanh toán: {{ formatCurrency(amountToBePaid) }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <span style="font-weight: bold;">
                  <v-icon color="#000">
                    mdi-circle-small
                  </v-icon>
                  Số tiền thanh toán lần này: <span style="color: green">{{ extraData ? formatCurrency(extraData.body.orderReceipt.amount) :  formatCurrency(stepMoney) }}</span>
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" class="py-0">
            <v-row>
              <v-col class="pt-0 pb-0">
                <span style="font-weight: bold;">
                  <v-icon color="#000">
                    mdi-circle-small
                  </v-icon>
                  Phương thức thanh toán:
                  {{ extraData ? extraData.body.orderReceipt.paymentMethod : (getPaymentMethod(paymentType))  }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-3 pb-2">
                <span style="font-weight: bold;">
                  <v-icon color="#000">
                    mdi-circle-small
                  </v-icon>
                  Thông tin nhận hàng:
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="px-12 pt-3">
                <validation-provider
                  v-slot="{ errors }"
                  :name="'Tên người nhận'"
                  :rules="{ required: true, max: 100 }"
                >
                  <v-text-field
                    label="Tên người nhận"
                    :error-messages="errors"
                    class="text-field-custom"
                    placeholder="Nhập tên người nhận"
                    dense
                    v-model.trim="receiverNameClone"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="6" class="px-12 pt-3">
                <validation-provider
                  v-slot="{ errors }"
                  :name="'Số điện thoại'"
                  :rules="{ required: true, max: 12 }"
                >
                  <v-text-field
                    label="Số điện thoại"
                    :error-messages="errors"
                    class="text-field-custom"
                    placeholder="Nhập số điện thoại"
                    dense
                    type="number"
                    v-model.trim="phoneClone"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="px-12 pt-1">
                <validation-provider
                  v-slot="{ errors }"
                  :name="'Tỉnh / T.P'"
                  :rules="{ required: true }"
                >
                  <v-autocomplete
                    :items="listProvince"
                    :error-messages="errors"
                    item-value="id"
                    item-text="ten"
                    :aLight="'right'"
                    placeholder="Lựa chọn"
                    label="Tỉnh / T.P"
                    attach
                    dense
                    v-model="provinceIdClone"
                    @change="getDistricts()"
                    :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-12 pt-1">
                <validation-provider
                  v-slot="{ errors }"
                  :name="'Quận/Huyện'"
                  :rules="{ required: true }"
                >
                  <v-autocomplete
                    :items="listDistrict"
                    :error-messages="errors"
                    item-value="id"
                    item-text="ten"
                    :aLight="'right'"
                    placeholder="Lựa chọn"
                    label="Quận/Huyện"
                    attach
                    dense
                    @change="getWards()"
                    v-model="districtIdClone"
                    :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-12 pt-1">
                <validation-provider
                  v-slot="{ errors }"
                  :name="'Phường/Xã'"
                  :rules="{ required: true }"
                >
                  <v-autocomplete
                    :items="listWard"
                    :error-messages="errors"
                    item-value="id"
                    item-text="ten"
                    :aLight="'right'"
                    placeholder="Lựa chọn"
                    label="Phường/Xã"
                    attach
                    dense
                    v-model="wardIdClone"
                    :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-12 pt-1">
                <validation-provider
                  v-slot="{ errors }"
                  :name="'Địa chỉ chi tiết'"
                  :rules="{ required: true, max: 255 }"
                >
                  <v-text-field
                    label="Địa chỉ chi tiết ( số nhà, đường, thôn,...)"
                    :error-messages="errors"
                    class="text-field-custom"
                    placeholder="Nhập địa chỉ chi tiết ( số nhà, đường, thôn,...)"
                    dense
                    v-model.trim="detailAddressClone"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <div class="px-2 mt-2" style="border: 1px solid #989898; border-radius: 10px;background: rgb(235, 235, 235);">
        <v-row>
          <v-col class="py-0" cols="12">
            <v-simple-table class="table-layout table-products" style="background: rgb(235, 235, 235);">
              <thead>
                <tr>
                  <th class="col-program" style="min-width:50px">#</th>
                  <th class="col-program text-left">TÊN SẢN PHẨM</th>
                  <th class="col-program" style="min-width:70px">SỐ GÓI</th>
                  <th class="col-program">ĐƠN GIÁ</th>
                  <th class="col-program">KHUYẾN MÃI</th>
                  <th class="col-program">THÀNH TIỀN</th>
                  <th class="col-program text-left" style="min-width:150px">TÀI KHOẢN CON</th>
                  <th class="col-program">THỜI HẠN</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in products" :key="index">
                  <td class="text-center">({{ index + 1 }})</td>
                  <td class="text-left">{{ item.productName }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ formatCurrency(item.price) }}</td>
                  <td>{{ formatCurrency(item.discount) }}</td>
                  <td>
                    <span v-if="item.productId">
                      {{ (item.price * item.count - item.discount) > 0 ? formatCurrency(item.price * item.count - item.discount) : '0' }}
                    </span>
                    <span v-else>0 (đ)</span>
                  </td>
                  <td class="text-left">{{ childObj[item.customerId] }}</td>
                  <td>{{item.type === 'duo' ? showEndDate(item) : '--'}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <hr style="display: block; height: 1px; border: 0; border-top: 1px solid #D4d4d4; margin: 1em 0; padding: 0;">
        <v-row>
          <v-col offset="8" cols="4" class="py-0">
            <v-row>
              <v-col cols="6" class="py-0">
                <p style="margin-bottom: 8px;">Tổng tiền sản phẩm</p>
                <p style="margin-bottom: 8px;">Tổng tiền được giảm</p>
                <p style="margin-bottom: 8px;">Tổng thành tiền</p>
              </v-col>
              <v-col cols="6" class="py-0">
                <p class="text-right" style="margin-bottom: 8px;">{{ formatCurrency(totalMoney) }}</p>
                <p class="text-right" style="margin-bottom: 8px;">{{ formatCurrency(totalDiscount) }}</p>
                <p class="text-right" style="margin-bottom: 8px;">{{ formatCurrency(totalPay) }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col cols="3">
              <div class='d-flex'><v-icon style="color:#0075FF">mdi-package-variant-closed-plus</v-icon><div class="mx-2 font-weight-bold">SẢN PHẨM KHUYẾN MẠI TẶNG KÈM</div></div>
            </v-col>
          </v-row>
          <v-row v-if="!skuInCampaign.length">
            <v-col class="px-5" style="padding: 0px;font-style: italic;">Đơn hàng không áp dụng khuyến mại tặng sản phẩm</v-col>
          </v-row>
          <template v-else>
            <v-row v-for="(itemCp, indexCp) in skuInCampaign" :key="indexCp" >
              <v-col cols="12" class="mb-2" style="padding: 0px 12px">
                <span class="mx-2">({{ itemCp.index + 1 }})</span>
                {{ itemCp.quantity }} x  {{ itemCp.skuName}}
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="py-3" cols="6 ">
          <span class="font-weight-bold"> 
            <v-icon color="#0075ff">
              mdi-message-text-outline
            </v-icon>
            Note cho vận đơn
          </span>
        </v-col>
        <v-col class="py-3" cols="6 ">
          <span class="font-weight-bold"> 
            <v-icon color="#0075ff">
              mdi-message-text-outline
            </v-icon>
            Note cho vận hành
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0" cols="6">
          <validation-provider
            v-slot="{ errors }"
            :name="'Ghi chú cho bộ phận vận đơn'"
            :rules="{ max: 255 }"
          >
            <v-textarea
              outlined
              :error-messages="errors"
              rows="3"
              class="ma-0 pa-0 text-area-custom"
              placeholder="Ghi chú cho bộ phận vận đơn..."
              v-model.trim="description"
            />
          </validation-provider>
        </v-col>
        <v-col class="py-0" cols="6">
          <validation-provider
            v-slot="{ errors }"
            :name="'Ghi chú cho bộ phận vận hành'"
            :rules="{ max: 255 }"
          >
            <v-textarea
              outlined
              :error-messages="errors"
              rows="3"
              class="ma-0 pa- text-area-custom"
              placeholder="Ghi chú cho bộ phận vận hành..."
              v-model.trim="operatingNote"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <v-btn
            class="btn-success"
            @click.prevent="handleSubmit(createOrder)"
            color="#35b707"
            height="38"
            width="100"
            :disabled="disableForm"
          >
            <span>Tạo đơn</span>
          </v-btn>

          <v-btn
            class="btn-cancel"
            color="#b70727"
            height="38"
            width="100"
            @click="close()"
          >
            Hủy
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-card>
</template>
<script>
import { getDiscount } from '@/helpers/campaign';
import RepositoryFactory from '@/repositories/RepositoryFactory';
import {RECORD_TYPE} from "../../../../helpers/constants";
const AddressRepository = RepositoryFactory.get('address');
const OrderRepository = RepositoryFactory.get('order');

export default {
  name: 'ConfirmOrder',
  data() {
    return {
      listWard: [],
      listDistrict: [],
      provinceIdClone: this.provinceId,
      districtIdClone: this.districtId,
      wardIdClone: this.wardId,
      paymentPeriodTxt: null,
      receiverNameClone: this.receiverName, 
      phoneClone: this.phone, 
      detailAddressClone: this.detailAddress, 
      childObj: {},
      description: null,
      operatingNote: null,
      disableForm: false,
      // totalMoney: 0,
      // stepMoney: 0,
      skuInCampaign: [],
      endDateCO: [],
      endDateCP: [],
    };
  },
  props: {
    paymentTypes: {
      type: Array,
      default: () => [],
    },
    trialExchangePriceType: {
      type: Number,
      default: 1,
    },
    noteSortClass: {
      type: String,
      default: '',
    },
    timelineEvents: {
      type: Array,
      default: () => [],
    },
    listProvince: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    paymentPeriod: {
      type: Number,
      default: () => null,
    },
    paymentType: {
      type: String,
      default: () => null,
    },
    isNotTrail: {
      type: Boolean,
      default: () => false,
    },
    isTrail: {
      type: Boolean,
      default: () => false,
    },
    receiverName: {
      type: String,
      default: () => null,
    },
    phone: {
      type: String,
      default: () => null,
    },
    detailAddress: {
      type: String,
      default: () => null,
    },
    wardId: {
      type: Number,
      default: () => null,
    },
    districtId: {
      type: Number,
      default: () => null,
    },
    provinceId: {
      type: Number,
      default: () => null,
    },
    paymentPeriods: {
      type: Array,
      default: () => [],
    },
    childs: {
      type: Array,
      default: () => [],
    },
    stepMoney: {
      type: Number,
      default: () => 0,
    },
    contactId: {
      type: Number,
      default: () => null,
    },
    extraData: {
      type: Object,
      default: () => null,
    },
    listProductConversion: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    issUpSaleOrder() {
      return this.$route.query.record_type === RECORD_TYPE.UPSALE;
    },
    totalDiscount() {
      let val = 0;
      for (let prod of this.products) {
        val += prod.discount || 0;
      }
      return val;
    },
    totalMoney() {
      let val = 0;
      for (let prod of this.products) {
        val += (prod.count || 0) * (prod.price || 0);
      }
      return val;
    },
    totalPay() {
      return Math.max(0, this.totalMoney - this.totalDiscount);
    },
    amountToBePaid() {
      if (this.timelineEvents?.length) {
        let val = this.totalPay;
        this.timelineEvents.forEach((item) => {
          if (item.status === "final_success") {
            val -= item.amount || 0;
          }
        });
        return val;
      }
      return 0;
    },
  },
  created() {
    this.products.forEach((prod, index) => {
      if (prod.campaigns) {
        prod.campaigns.forEach((item) => {
          if (item.giftSelected?.length > 0) {
            this.skuInCampaign.push({
              index,
              ...item.giftSelected[0],
            });
          }
        })
      }
    })
    this.operatingNote = _.cloneDeep(this.noteSortClass);
    const pP = this.paymentPeriods.find(item => item.id === this.paymentPeriod);
    this.paymentPeriodTxt = pP.name;
    this.childs.forEach((item) => {
      this.childObj[item.id] = item.fullName;
    });

    if (this.provinceId) {
      this.getDistricts();
    }
    this.districtIdClone = this.districtId;
    if (this.provinceId && this.districtId) {
      this.getWards();
    }
    this.wardIdClone = this.wardId;
    if (!this.extraData) this.getEndDateCO();
    if (this.extraData) this.getEndDateCP();
  },

  methods: {
    getPaymentMethod(data) {
      const paymentReceipt = this.paymentTypes.find(item => item.id == data);
      if((paymentReceipt && paymentReceipt.value ) || data === 'MONEY_RECEIPT') {
        return  'Biên nhận';
      }else {
        return data;
      }
    },

    totalProduct (item) {
      if(item.idBlock) {
        const findProduct = this.listProductConversion.find(data => data.id === item.idBlock)
        if(findProduct) {
          return findProduct.paymentUnitAmount * Number(item.trailLessons)
        }
      }
      return 0

    },
    async createOrder() {
      if (this.extraData) {
        this.extraData.body.shippingAddress = {
          receiver: this.receiverNameClone,
          phone: this.phoneClone,
          // "email": "",
          tinhId: this.provinceIdClone,
          huyenId: this.districtIdClone,
          xaId: this.wardIdClone,
          detailAddress: this.detailAddressClone,
        };
        const body = this.extraData.body;
        body.description = this.description;
        body.noteSortClass = this.operatingNote;
        const res = await OrderRepository.extraPayment(body);
        if (res && res.errors) {
          this.$swal({
            title: "Lỗi",
            text: res.message ? res.message : "Có lỗi xảy ra!!!",
            icon: "error",
            timer: 2000,
          });
        } else {
          this.$swal({
            type: 'success',
            title: 'Thông báo',
            text: 'Thanh toán thêm thành công',
            icon: "success",
            timer: 2000,
          });
          return this.$emit('createExtraSuccess');
        }
        return;
      }
      let totalPrice = 0;
      const products = this.products.map((item) => {
        totalPrice += ((item.price * item.count) - item.discount);
        if (totalPrice < 0) totalPrice = 0;
        const campaigns = item.campaigns.map((itemC) => {
          return {
            code: itemC.code,
            type: itemC.type,
            giftIndexes: this.issUpSaleOrder ? (itemC.giftIndexes >= 0 ? itemC.giftIndexes : []) : (itemC.giftIndex >= 0 ? [itemC.giftIndex] : []),
            promotionSubCode: itemC.raw.promotionSubCode ? itemC.raw.promotionSubCode : null,
          };
        });
        return {
          orderType: item.isNew ? 1 : 2,
          productId: item.productId,
          productType: `sku_${item.type}`,
          quantity: item.count, // số gói
          customerId: item.customerId,
          activeType: item.activeType,
          price: item.price, // đơn giá
          intoMoney: ((item.price * item.count) - item.discount) > 0 ? ((item.price * item.count) - item.discount) : 0, // thành tiền
          campaigns,
        };
      });

      let trailProduct = [];
      if (this.isTrail) {
        // TODO
        this.products.forEach((item) => {
          if (item.type !== 'combo') {
            trailProduct.push({
              trailLessons: item.trailLessons, // thời hạn học thử
              productId: item.productId, // id sản phầm
              productType: `sku_${item.type}`, 
              money: this.totalProduct(item) ? this.totalProduct(item) : item.trailLessons * (item.type == 'tutor' ? item.baseOrgPrice : Math.ceil(item.baseOrgPrice/item.duration*1.5)), // thành tiền
              customerId: item.customerId,
              numberOfSection: item.type == 'tutor' ? item.package.split('-')[1] : item.duration, // thời hạn gốc của sku
              trialExchangePriceType: this.trialExchangePriceType ? this.trialExchangePriceType : 1
            });
          }
          if (item.type === 'combo') {
            item.skuTutors.forEach((comboItem) => {
              trailProduct.push({
                trailLessons: comboItem.trailLessons, // thời hạn học thử
                productId: comboItem.id, // id sản phầm
                productType: 'sku_tutor', 
                money: comboItem.trailLessons * (comboItem.skuTutorPaymentUnit ? comboItem.skuTutorPaymentUnit.orgPrice : 0), // thành tiền
                customerId: item.customerId,
                numberOfSection: comboItem.package.split('-')[1], // thời hạn gốc của sku
                comboId: item.productId,
                trialExchangePriceType: this.trialExchangePriceType ? this.trialExchangePriceType : 1
              });
            });
            item.skuDuos.forEach((comboItem) => {
              trailProduct.push({
                trailLessons: comboItem.trailLessons, // thời hạn học thử
                productId: comboItem.id, // id sản phầm
                productType: 'sku_duo', 
                money: comboItem.trailLessons * Math.ceil(comboItem.orgPrice/comboItem.duration*1.5), // thành tiền
                customerId: item.customerId,
                numberOfSection: comboItem.duration, // thời hạn gốc của sku
                comboId: item.productId,
                trialExchangePriceType: this.trialExchangePriceType ? this.trialExchangePriceType : 1
              });
            });
          }
        });
      }
      const paymentReceipt = this.paymentTypes.find(item => item.id === this.paymentType);
      const params = {
        contactId: this.contactId,
        paymentType: (this.$route.query.record_type == 'transfer_product' && this.$route.query.record_id) ? 'BANK' :
            (paymentReceipt && paymentReceipt.value ? 'MONEY_RECEIPT' : this.paymentType),
        paymentPeriod: this.paymentPeriod, // thanh toán 1 lần/ thanh toán nhiều lần
        description: this.description, // Lưu ý cho vận đơn
        noteSortClass: this.operatingNote, // Lưu ý cho vận đơn
        totalPrice: totalPrice, // Tổng giá trị đơn
        products,
        // Địa chỉ nhận hàng
        shippingAddress: {
          receiver: this.receiverNameClone,
          phone: this.phoneClone,
          // "email": "",
          tinhId: this.provinceIdClone,
          huyenId: this.districtIdClone,
          xaId: this.wardIdClone,
          detailAddress: this.detailAddressClone,
        },
        // thông tin phiếu thu
        orderReceipt: {
          amount: this.stepMoney, // số tiền thanh toán lần này
          paymentMethod: this.paymentType, // map theo trường paymentType ở trên
        },
        schoolIds : [], // tạm để rỗng
        // danh sách sản phẩm học thử
        trailProduct: trailProduct && trailProduct.length ? trailProduct : null,
      };
      // const paymentReceipt = this.paymentTypes.find(item => item.id === this.paymentType);
      if(paymentReceipt && paymentReceipt.value) {
        params.orderReceipt.paymentMethod = 'MONEY_RECEIPT';
        params.paymentReceiptId = paymentReceipt.value;
      }
      if (this.$route.query.record_type == 'transfer_product' && this.$route.query.record_id) {
        if(this.$route.query && this.$route.query.isDuo) {
          params.crossFeeTransferProductDataId = this.$route.query.record_id;
        }else {
        params.tutorTransferProductDraftId = this.$route.query.record_id;
        }
      }
      if (this.$route.query.record_type === RECORD_TYPE.UPSALE && this.$route.query.record_id) {
        params.orderProductTransferDraftId = this.$route.query.record_id;
        params.paymentType = null
      }
      this.disableForm = true;
      let res= ''
      if(this.issUpSaleOrder) {
        res = await OrderRepository.createUpsaleOrderApi(params);
      }else if(this.$route.query && this.$route.query.isDuo) {
        res = await OrderRepository.createCrossFeeTransferProductApi(params);
      }
      else{
        res = await OrderRepository.createOrderV2(params);
      }
      this.disableForm = false;
      if (res.data) {
        if (res.data.isExist) {
          return this.$swal({
            type: 'error',
            title: 'Thông báo',
            text: 'Thêm mới đơn hàng không thành công. Số điện thoại người nhận đã tồn tại!',
          });
        } else {
          this.$swal({
            type: 'success',
            title: 'Thông báo',
            text: 'Tạo đơn hàng thành công',
          });
          this.$emit('createSuccess');
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: res.message,
        });
      }
    },
    close() {
      this.$emit('close');
    },
    async getDistricts() {
      this.districtIdClone = null;
      this.wardIdClone = null;
      this.listWard = [];
      const respond = await AddressRepository.districts(
        { limit: 100 },
        this.provinceIdClone,
      );
      if (_.get(respond, 'success', false)) {
        this.listDistrict = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },

    async getWards() {
      this.wardIdClone = null;
      const respond = await AddressRepository.wards(
        { limit: 100 },
        this.provinceIdClone,
        this.districtIdClone
      );
      if (_.get(respond, 'success', false)) {
        this.listWard = _.get(respond, 'data', []);

      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getEndDateCO() {
      const products = this.products.map((item) => {
        const product = {
          productId: item.productId,
          productType: `sku_${item.type}`,
          customerId: item.customerId
        };
        if (item.type === 'duo' && item.activeType) {
          product.activeType = item.activeType;
        }
        return product;
      });
      let trailProduct = [];
      if (this.isTrail) {
        // TODO
        this.products.forEach((item) => {
          if (item.type !== 'combo') {
            trailProduct.push({
              trailLessons: item.trailLessons, // thời hạn học thử
              productId: item.productId, // id sản phầm
              productType: `sku_${item.type}`, 
              customerId: item.customerId,
            });
          }
          if (item.type === 'combo') {
            item.skuTutors.forEach((comboItem) => {
              trailProduct.push({
                trailLessons: comboItem.trailLessons, // thời hạn học thử
                productId: comboItem.id, // id sản phầm
                productType: 'sku_tutor', 
                customerId: item.customerId,
                comboId: item.productId,
              });
            });
            item.skuDuos.forEach((comboItem) => {
              trailProduct.push({
                trailLessons: comboItem.trailLessons, // thời hạn học thử
                productId: comboItem.id, // id sản phầm
                productType: 'sku_duo', 
                customerId: item.customerId,
                comboId: item.productId,
              });
            });
          }
        });
      }
      const params = {
        orderReceiptAmount: this.stepMoney, // Giá trị phiếu thu
        paymentPeriod: this.paymentPeriod, // Loại thanh toán một lần, nhiều lần
        totalPrice: this.totalPay,
        products,
        trailProduct,
      }
      const res = await OrderRepository.getEndDateCO(params);
      if (res && res.errors) {
        this.$swal({
          title: "Lỗi",
          text: res.message ? res.message : "Có lỗi xảy ra!!!",
          icon: "error",
          timer: 2000,
        });
      } else {
        this.endDateCO = res.data;
      }
    },
    showEndDate(item) {
      const endDate = !this.extraData ? this.endDateCO.find((it) => it.productId === item.productId) : this.endDateCP.find((it) => it.productId === item.productId);
      if (endDate) {
        if (endDate.endDate) return this.formatDateDMY2(endDate.endDate);
        if (endDate.endMonth) return `${endDate.endMonth} tháng`;
        return '--';
      }
      return '--';
    },
    async getEndDateCP() {
      let trailProduct = null;
      if (this.isTrail) {
        // TODO
        trailProduct = this.extraData.body.trailProduct.map((item) => {
          return {
            trailLessons: item.trailLessons, // thời hạn học thử
            productId: item.productId, // id sản phầm
            productType: item.productType, 
            customerId: item.customerId,
            comboId: item.comboId ? item.comboId : null,
            orderProductId: item.orderProductId ? item.orderProductId : null,
          };
        })
      }
      const params ={
        orderId: this.extraData.body.orderId,
        orderReceiptAmount: this.extraData.body.orderReceipt.amount, // Giá trị thanh toán của phiếu thu lần tới
        trailProduct,
      }
      const res = await OrderRepository.getEndDateCP(params);
      if (res && res.errors) {
        this.$swal({
          title: "Lỗi",
          text: res.message ? res.message : "Có lỗi xảy ra!!!",
          icon: "error",
          timer: 2000,
        });
      } else {
        this.endDateCP = res.data;
      }
    },
  },

}
</script>

<style lang="scss" scoped>
.form-title {
  position: absolute;
}
.close-btn {
  position: relative;
  left: 98%;
}
.text-area-custom {
  ::-webkit-input-placeholder {
    font-style: italic;
  }
  :-moz-placeholder {
    font-style: italic;  
  }
  ::-moz-placeholder {
    font-style: italic;  
  }
  :-ms-input-placeholder {  
    font-style: italic; 
  }
}
</style>
